<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      quick-search-props=""
      :default-sorter="[{ direction: 'DESC', property: 'createTime' }]"
      :show-export="false"
      :show-custom-column="false"
      ref="ecoTable"
    >
      <template>
        <eco-table-column
          type="index"
          width="50"
          align="center"
          label="序号"
        />
        <eco-table-column
          prop="name"
          label="属性名称"
          :sortable="true"
          :show-overflow-tooltip="true"
        >
          <template v-slot="{ row }">
            <el-link
              type="primary"
              @click="showDialog(row.id)"
              title="编辑详情"
            >{{ row.name }}</el-link>
          </template>
        </eco-table-column>
        <eco-table-column
          prop="alias"
          label="属性代码"
          :sortable="true"
          :show-overflow-tooltip="true"
        />
        <eco-table-column
          prop="encrypt"
          label="存储方式"
          width="120"
          :filters="[
            { text: '加密存储', value: '1' },
            { text: '明文存储', value: '0' }
          ]"
        >
          <template v-slot="{ row }">
            <el-tag
              type="info"
              v-if="row.encrypt == '0'"
            >明文存储</el-tag>
            <el-tag
              type="warning"
              v-if="row.encrypt == '1'"
            >加密存储</el-tag>
          </template>
        </eco-table-column>
      </template>
      <eco-table-column
        prop="description"
        label="属性说明"
        width="250"
        :show-overflow-tooltip="true"
      />
    </eco-table>
    <el-drawer
      class="sideDrawer"
          destroy-on-close
:size="drawerSize"
      title="系统属性编辑"
      :visible="dialogVisible"
      v-if="dialogVisible"
      :before-close="beforeCloseDialog"
      append-to-body
    >
      <i
        class="iconfont icon-back-quanping iconFull"
        @click="drawerSize = '100%'"
        v-if="drawerSize == '70%'"
      />
      <i
        @click="drawerSize = '70%'"
        class="iconfont icon-back-tuichuquanping iconFull"
        v-else
      />
      <el-form
        v-form
        data-vv-scope="propertyForm"
        style="padding: 10px 20px"
      >
        <eco-form-item label="属性名称">
          <eco-input
            v-model="currentProperty.name"
            validate="required"
            style="width: 100%"
          />
        </eco-form-item>
        <eco-form-item label="属性代码">
          <eco-input
            v-model="currentProperty.alias"
            validate="required"
            style="width: 100%"
          />
        </eco-form-item>
        <eco-form-item label="属性值">
          <!-- <eco-input
            type="textarea"
            :rows="5"
            v-model="currentProperty.value"
            validate="required"
          /> -->
          <el-input-number
            v-model="currentProperty.value"
            :min="1"
            style="width: 100%"
            :max="1440"
            :controls="false"
            label="请输入超时时间"
          ></el-input-number>
        </eco-form-item>
        <eco-form-item label="存储方式">
          <eco-radio
            v-model="currentProperty.encrypt"
            :options="[
              { key: 0, value: '明文存储' },
              { key: 1, value: '加密存储' }
            ]"
          />
        </eco-form-item>
        <eco-form-item label="属性说明">
          <eco-input
            style="width: 100%"
            type="textarea"
            v-model="currentProperty.description"
            :rows="5"
          />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="beforeCloseDialog">{{
          $t("eip.common.cancel")
        }}</el-button>
        <fe-submit-button
          :url="saveUrl"
          :model="currentProperty"
          scope-name="propertyForm"
          @after-save-data="afterSaveData"
        >{{ $t("eip.common.save") }}</fe-submit-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import portal from '@/api/portal.js'

export default {
  data() {
    return {
      drawerSize: '70%',
      dialogVisible: false,
      data: [],
      saveUrl: `${window.context.portal}/sys/sysProperties/v1/save`,
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      currentProperty: { encrypt: 1 }
    }
  },
  mounted() {
    this.$validator = this.$root.$validator
  },
  methods: {
    showDialog(id) {
      if (id) {
        portal.getSysProperty(id).then((response) => {
          this.currentProperty = response
          this.dialogVisible = true
        })
      } else {
        this.dialogVisible = true
      }
    },
    beforeCloseDialog() {
      this.currentProperty = { encrypt: 1 }
      this.dialogVisible = false
    },
    loadData(param, cb) {
      if (!param.querys) {
        param.querys = [
          {
            group: 'advance',
            value: 'overTime',
            relation: 'AND',
            operation: 'EQUAL',
            property: 'alias'
          }
        ]
      }
      portal
        .getSysProperties(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    afterSaveData() {
      setTimeout(() => {
        this.beforeCloseDialog()
        this.$refs.ecoTable.load()
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.sp-manager__dialog /deep/ > .el-dialog > .el-dialog__body {
  height: calc(100% - 170px);
}
::v-deep .common-tools {
  min-height: 5px !important;
}
</style>
